import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../../../hooks/useAuth'
import { societyQueries } from '../../../api/societies'
import { useSelectedSocietyId } from '../../../hooks/useSelectedSocietyContext'
import { unitQueries } from '../../../api/units'
import { widgetQueries } from '../../../api/society-widgets'

export const useSocietyLoader = (id: string | undefined): void => {
  const { userId } = useAuth()

  const { data, isLoading } = useQuery(societyQueries.getUserSocieties(userId))
  const { setCurrentSocietyId, selectedSocietyId } = useSelectedSocietyId()

  useEffect(() => {
    if (userId && !isLoading) {
      if (!id) {
        if (selectedSocietyId) return
        if (data) {
          const firstSociety = data[0]
          firstSociety && setCurrentSocietyId(firstSociety._id)
        }
      } else {
        setCurrentSocietyId(id)
      }
    }
  }, [data, id, isLoading, setCurrentSocietyId, selectedSocietyId, userId])

  useQuery(unitQueries.getUserUnits(userId))
  useQuery(widgetQueries.getWidgetsPerSociety(id))
}
